module.exports = __webpack_public_path__ + "static/img/logo-footer.715baecd.png";